import React, { useState, useEffect } from 'react';
//import { unstable_batchedUpdates as batchedUpdates } from 'react-dom';
import { postDataFetcher } from '../../../dataFetcher';
import CONFIG_OBJECT from '../../../config/config';
import GenderList from './GenderList.js'
import NameDetail from './NameDetail'
import Error from '../Common/Error'
import Pagination from "react-js-pagination";
import Loader from '../Common/Loader'
//import configData from '../../../temp/config';
import App_Constants from '../../../app-constants/App_Constants';

// General scroll to element function
//const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

const ResultTable = (props) => {

    const [searchterm, setSearchterm] = useState()

    const [showNameTable, setShowNameTable] = useState(false)
    const [showSimNameTable, setShowSimNameTable] = useState(false)
    const [showNameDetail, setShowNameDetail] = useState(false)
    //const myRef = useRef(null)
    //const executeScroll = () => scrollToRef(myRef)    

    const [results, setResults] = useState({
        apiData: {},
        newtableHeader: [],
        newPosts: [],
        newBabyResults: [],
        pagination:{}
    })

    const [similarResults, setSimilarResults] = useState({
        apiData: {},
        newtableHeader: [],
        newPosts: [],
        newBabyResults: [],
        newSimilarNames: [],
        pagination: {}
    })
    
    const [errorData, setErrorData] = useState()
    const [loader, setLoader] = useState(false)
    const [searchText, setSearchText] = useState(props.name)
    const [nameSearchText, setNameSearchText] = useState()
    const [counter, setCounder] = useState(false)

    /* Assign Variable for Pagination */
    const [currentPage, setCurrentPage] = useState(1)
    const [simCurrentPage, setSimCurrentPage] = useState(1)
    const [nameCurrentPage, setNameCurrentPage] = useState(1)
    const [responseData] = useState(props.resultData)
    const eventDataHandler = (setResponseData) => { setResponseData(resData) }

    const [resData, setResData] = useState({
        data: props.reultData,
        status: false,
        type: props.sType
    })

    /* Fucntion to fetch Name results by using Alphabet and  Meaning*/
    const loading = async (data) => {   
        
        setLoader(true)
        setErrorData('')
        let pnumber
        if(counter){
            pnumber = 1
            setCounder(false)
        } else {
            pnumber = searchText === data.name ? currentPage : 1
        }
        setSearchText(data.name)
        let sTypevalue = data.sType !== null ? data.sType : ''
        let sTermValue = data.name !== null ? data.name : ''
        let gTypeValue = "";
        if(data.sType !== 'searchbyalphabet'){            
            gTypeValue = data.gType !== null ? data.gType : ''
        }
        setSearchterm(sTermValue)
        const initialData = {
            searchtype: sTypevalue,
            searchterm: sTermValue,
            gender: gTypeValue,
            pagenumber: pnumber
        }        
        return ( 
            postDataFetcher(`${CONFIG_OBJECT.BNF_REST_URL}${App_Constants.SC_API_KEY}`,initialData)            
            .then(res => {            
                Promise.resolve()
                .then(() => {                                        
                    if(res.data.Data.babyNamesResult !== null){  
                        setResData({
                            data: '',
                            status: false,
                            type: props.sType
                        })          
                        setResults({
                            apiData: res.data.Data,
                            newtableHeader: res.data.Data.babyNamesResult.resultHeaderTitles,
                            newPosts: res.data.Data.babyNamesResult.babyNamesList,
                            newBabyResults: res.data.Data.babyNamesResult,
                            pagination: res.data.Data.babyNamesResult.babyNamesPagination
                        })
                        setShowNameTable(true)
                        setCurrentPage(pnumber)
                    } else {                        
                        setErrorData(res.data.Data.message)
                        setResData({
                            data: res.data.Data.message,
                            status: true,
                            type: props.sType
                        }) 
                    }                    
                    setLoader(false) 
                })
            })
            .catch(err => {
                if (err.response) {
                    // client received an error response (5xx, 4xx)
                    setErrorData(err.response.data.Error)
                    setResData({
                        data: err.response.data.Error,
                        status: true,
                        type: props.sType
                    })                  
                } else if (err.request) {
                    // client never received a response, or request never left
                    console.log(err.request)                  
                } else {
                  // anything else
                  console.log(err)
                }
            })            
        )
    }

    useEffect(() => {        
        setShowSimNameTable(false) 
        setShowNameTable(false)
        setShowNameDetail(false)        
        if(props.sType === 'searchbyalphabet' || props.sType === 'searchbymeaning'){
            loading(props);
        }
        else{
            similarResult(props)            
        }
    }, [props, currentPage]) 

    /* Fucntion to fetch Similar Name results */
    const similarResult = async (data) => {

        console.log('similarResult', data)

        setLoader(true)
        setShowSimNameTable(false)        
        setErrorData('')
        
        let pnumber = nameSearchText === props.name ? nameCurrentPage : 1
        setNameSearchText(props.name)
        
        let sTypevalue = data.sType !== null ? data.sType : ''
        let sTermValue = data.name !== null ? data.name.toString() : ''
        let gTypeValue = "";
        if(data.sType !== 'searchbyalphabet'){
            gTypeValue = data.gType !== null ? data.gType : ''
        }      
        setSearchterm(sTermValue)
        const similarData = {
            searchtype: sTypevalue,
            searchterm: sTermValue.toString(),
            gender: gTypeValue,
            pagenumber: pnumber
        }
        return (
            postDataFetcher(`${CONFIG_OBJECT.BNF_REST_URL}${App_Constants.SC_API_KEY}`,similarData)
            .then(res => {            
                Promise.resolve()
                .then(() => {
                    if(res.data.Data.babyNamesResult !== null ){
                        setResData({
                            data: null,
                            status: false,
                            type: props.sType
                        }) 
                        setSimilarResults({
                            apiData: res.data.Data,
                            newtableHeader: res.data.Data.babyNamesResult.resultHeaderTitles,
                            newPosts: res.data.Data.babyNamesResult.babyNamesList,
                            newBabyResults: res.data.Data.babyNamesResult,
                            newSimilarNames: res.data.Data.babyNamesResult.similarBabyNamesList,
                            pagination: res.data.Data.babyNamesResult.similarBabyNamesPagination
                        })
                        setShowSimNameTable(true)
                        setNameCurrentPage(pnumber)
                        setCounder(true)
                    } else {
                        setErrorData(res.data.Data.message)
                        setResData({
                            data: res.data.Data.message,
                            status: true,
                            type: props.sType
                        })
                    }
                    setLoader(false)                    
                })                
            })
            .catch(err => {
                if (err.response) {
                    // client received an error response (5xx, 4xx)
                    setErrorData(err.response.data.Error)
                    setResData({
                        data: err.response.data.Error,
                        status: true,
                        type: props.sType
                    })                  
                } else if (err.request) {
                    // client never received a response, or request never left
                    console.log(err.request)                  
                } else {
                  // anything else
                  console.log(err)
                }
            }) 
        )        
    }
    
    /* Fucntion to fetch Name Details */
    const displayName = async (e) => {        
        e.preventDefault()
        setLoader(true)
        setShowNameTable(false)
        setShowNameDetail(false) 
        setErrorData('')

        let pnumber
        if(props.sType === 'searchbyalphabet' || props.sType === 'searchbymeaning'){
            setCurrentPage(currentPage)
            setSearchText(searchText)            
        }
        
        pnumber = searchText === e.target.innerHTML ? simCurrentPage : 1
        setNameSearchText(e.target.innerHTML)

        let sTypevalue = "searchbyname"
        let sTermValue = e.target.innerHTML !== null ? e.target.innerHTML : ''
        let gTypeValue = "";
        if(props.sType !== 'searchbyalphabet'){
            gTypeValue = props.gType !== null ? props.gType : ''
        } 

        setSearchterm(sTermValue)

        const searchData = {
            searchtype: sTypevalue,
            searchterm: sTermValue,
            gender: gTypeValue,
            pagenumber: pnumber
        }

        return (
            postDataFetcher(`${CONFIG_OBJECT.BNF_REST_URL}${App_Constants.SC_API_KEY}`,searchData)
            .then(res => {            
                Promise.resolve()
                .then(() => {
                    if(res.data.Data !== null){                        
                        setResData({
                            data: '',
                            status: false,
                            type: props.sType
                        }) 
                        setSimilarResults({
                            apiData: res.data.Data,
                            newPosts: res.data.Data.babyNamesResult.babyNamesList,
                            newBabyResults: res.data.Data.babyNamesResult,
                            newSimilarNames: res.data.Data.babyNamesResult.similarBabyNamesList,
                            pagination: res.data.Data.babyNamesResult.similarBabyNamesPagination
                        })
                        setShowNameTable(true)
                        setShowNameDetail(true)
                        setSimCurrentPage(pnumber)
                    } else {
                        setErrorData(res.data.Data.message)
                        setResData({
                            data: res.data.Data.message,
                            status: true,
                            type: props.sType
                        })
                    }
                    setLoader(false)                    
                })                
            })
            .catch(err => {
                if (err.response) {
                    // client received an error response (5xx, 4xx)
                    setErrorData(err.response.data.Error)
                    setResData({
                        data: err.response.data.Error,
                        status: true,
                        type: props.sType
                    })                  
                } else if (err.request) {
                    // client never received a response, or request never left
                    console.log(err.request)                  
                } else {
                  // anything else
                  console.log(err)
                }
            }) 
        )  
    }
    useEffect(() => {
        eventDataHandler(responseData)
    },[resData])
    
    //Navigate to the page
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }
    

    let [thname, thgender, thmeaning] = [results.newtableHeader.name, results.newtableHeader.gender, results.newtableHeader.meaning]
    return(        
        loader ? <Loader /> :
        showNameTable ? 
            <div className="blk blk-result table-result">
            {
            showNameDetail ? 
                    <NameDetail 
                        BabyData={similarResults.newPosts} 
                        ResultData={similarResults.newBabyResults} 
                        SimilarData={similarResults.newSimilarNames}
                        paginationData={similarResults.pagination}
                        currentPage={currentPage} 
                        paginate={paginate}
                    />  :
                <React.Fragment>
                <h4>{results.apiData.babyNamesResult.babyNamesTitle}</h4>
                <table>
                    <thead>
                        {
                            <tr>
                                <th className="namecolumn">{thname}</th>
                                <th className="gendercolumn">{thgender}</th>
                                <th className="meaningcolumn">{thmeaning}</th>
                            </tr>
                        }                        
                    </thead>
                    <tbody>                        
                        {
                            results.newPosts.map((data, index) => {
                                return (<tr key={index}>
                                    <td className="namecolumn">
                                        <a href="/" onClick={(event) => { displayName(event)} }>{data.name}</a>
                                    </td>
                                    <td className="gendercolumn">
                                        {
                                            <GenderList key={index} icons={results.newBabyResults.genderList} data={data.gender} />
                                        }
                                    </td>
                                    <td className="meaningcolumn">{data.meaning}</td>
                                </tr>)
                            })
                        }                        
                    </tbody>
                </table>
                {
                    (results.pagination !== null && results.pagination.totalCount > results.pagination.itemsPerPage) &&
                    <Pagination
                        //hideDisabled
                        firstPageText='first'
                        lastPageText='last'
                        activePage={currentPage}
                        itemsCountPerPage={results.pagination.itemsPerPage}
                        totalItemsCount={results.pagination.totalCount} 
                        pageRangeDisplayed={3}
                        onChange={paginate}
                    />
                    
                }  
                </React.Fragment>
            }              
        </div>
        :
        showSimNameTable ? 
        <div className="blk blk-result"> 
            <NameDetail 
                BabyData={similarResults.newPosts} 
                ResultData={similarResults.newBabyResults} 
                SimilarData={similarResults.newSimilarNames}
                paginationData={similarResults.pagination}
                currentPage={simCurrentPage} 
                paginate={paginate}
                searchterm={searchterm}
                searchtype={props.sType}
                gendertype={props.gType}
            />                
        </div>
        :
        <Error errormsg={errorData} />
    )
}

export default ResultTable;